/* eslint-disable */
import React, {Component} from 'react'
import ajax from '../utils/Ajax'
import checkResponse from '../utils/ServerResponses'
import Promise from 'bluebird'
import Notify from 'react-notify'
import errorReport from '../utils/errorReport'
import CampusSearch from '../components/CampusSearch'
import VendorSearch from '../components/VendorSearch'
import SelectRange from '../components/SelectRange'
import Payments from '../components/Payments/Payments'
import SearchButtons from '../components/SearchButtons'

const INITIAL_STATE = {
  vendorSearch: {VENDOR_ID:'',VENDOR_NAME:'Enter Search...'},
  campusSearch: {DEPTID:'',CAMPUS:'Enter Search...'},
  range: 6,
  ranges:[{value: 6,label:'0-6 Months'},{value: 12, label:'12 Months'},{value:18,label:'18 Months'},{value:24,label:'24 Months'},{value:10000,label:'All Payments'}],
  search:false,
  payments:[]
};

export default class VendorPaymentContainer extends Component {
  state = INITIAL_STATE;

  /**
   *
   * @param {string} [type=error,info,success]
   * @param title
   * @param message
   * @param duration 4 seconds
   */
  notify = (type='info',title,message,duration=4000)=>{
    this.Notifier[type](title,message,duration)
  };

  resetSearch = ()=>{
    this.setState(INITIAL_STATE)
  };

  campusInputChange = (campusSearch)=>{
    // for when user clicks input reset 'x' button
    if(!campusSearch) campusSearch = INITIAL_STATE.campusSearch;
      this.setState({campusSearch})
  };

  vendorInputChange = (vendorSearch)=>{
    // for when user clicks input reset 'x' button
    if(!vendorSearch) vendorSearch = INITIAL_STATE.vendorSearch;
    this.setState({vendorSearch})
  };

  selectRange = (range)=>{
    if(!range) range = INITIAL_STATE.range;
    return this.setState({range:range.value});
  };

  getCampuses = (q)=>{
    // Must enter 3 characters for search
    // ==================================
    if(!q || q.length < 3) return Promise.resolve({options:[]});
    return ajax.get(`/vendorCampuses`,{params:{$filter:`contains(campusSearch,"${q}")`,$orderby:'CAMPUS'}})
      .then(({status,data}) => {
      const {value} = data;
      // Check for Server Response Message
      // =================================
        const {type,message} = checkResponse(status);
      if(type !== 'success'){
        this.notify(type,`Server ${type}`, message);
        return {options:[]}
      }
      // All is well, process server response
      // ====================================
        return {options: value};
      })
      .catch((err)=>{
        errorReport(err);
        this.notify('error','Search Error',err.message);
      })
  };

  getVendors = (q)=>{
    // Must enter 3 characters for search
    // ==================================
    if(!q || q.length < 3) return Promise.resolve({options:[]});
    return ajax.get(`/vendorVendors`,{params:{$filter:`contains(vendorSearch,"${q}")`,$orderby:'VENDOR_NAME'}})
      .then(({status,data}) => {
        const {value} = data;
        // Check for Server Response Message
        // =================================
        const {type,message}= checkResponse(status);
        if(type !== 'success'){
          this.notify(type,`Server ${type}`, message);
          return {options:[]}
        }
        // All is well, process server response
        // ====================================
        return {options: value};
      })
      .catch((err)=>{
        errorReport(err);
        this.notify('error','Search Error',err.message);
      })
  };

  getPayments = ()=>{
    const { vendorSearch:{VENDOR_ID},campusSearch:{DEPTID}, range } = this.state;

    if(!VENDOR_ID && !DEPTID) return this.notify('error','Please Select Campus or Company');
    const search = [];
    if(VENDOR_ID) search.push(`VENDOR_ID eq ${VENDOR_ID}`);
    if(DEPTID) search.push(`DEPTID eq ${DEPTID}`);
    ajax.get(`/vendorPayments`,{params:{$filter: `${search.join(' AND ')} AND (MONTHS_OLD GE 0 AND MONTHS_OLD LE ${range})`, $orderby:'VENDOR_NAME,CAMPUS,RECEIVED_DATE DESC'}})
      .then(({status,data}) => {
        const {value} = data;
        // Check for Server Response Message
        // =================================
        const {type,message} = checkResponse(status);
        if(type !== 'success'){
          return this.notify(type,`Server ${type}`, message);
        }
        // All is well, process server response
        // ====================================
        this.setState({search:true,payments:value});
      })
      .catch((err)=>{
        errorReport(err);
        this.notify('error','Search Error',err.message);
    })
  };

  render() {
    const { vendorSearch,campusSearch,payments,search,ranges,range } = this.state;
    const buttonsDisabled = vendorSearch.VENDOR_ID === '%' && campusSearch.DEPTID === '%';
    return (
      <div className="vendor-payments">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <h3>Search By</h3>
          </div>
        </div>
        <div className="row">
          <CampusSearch
            value={campusSearch}
            onChange={this.campusInputChange}
            loadOptions={this.getCampuses}
          />
          <VendorSearch
            value={vendorSearch}
            onChange={this.vendorInputChange}
            loadOptions={this.getVendors}
          />
          <SelectRange
            selectRange={this.selectRange}
            value={range}
            ranges={ranges}
          />
          <SearchButtons
            search={this.getPayments}
            reset={this.resetSearch}
            searchRun={search}
            buttonsDisabled={buttonsDisabled}
          />
        </div>
        <div className="row">
          <Payments
            search={search}
            rows={payments}
          />
        </div>
        <Notify ref={(ref)=>{
          this.Notifier = ref;
        }} />
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/container/index.jsx